let mathJaxPromise;

function createMathJaxConfig() {
    return {
        tex: {
            macros: {
                bm: ["\\boldsymbol{#1}", 1],
                coloneq: "\\coloneqq",
            },
            inlineMath: [
                ["\\(", "\\)"],
                ["$", "$"],
            ],
            displayMath: [
                ["\\[", "\\]"],
                ["$$", "$$"],
            ],
            packages: {
                "[-]": ["html", "require"],
            },
            processEscapes: true,
            processEnvironments: true,
            useLabelIds: false,
        },
        options: {
            enableMenu: false,
        },
        startup: {
            typeset: false,
            ready() {
                window.MathJax.startup.defaultReady();

                const safe = window.MathJax?.startup?.document?.safe;
                if (safe?.filterAttributes && safe?.filterMethods) {
                    safe.filterAttributes.set("fontfamily", "filterFontFamily");
                    safe.filterMethods.filterFontFamily = (_safe, family) => family.split(/;/)[0];
                }
            },
        },
    };
}

export async function loadMathJax() {
    if (window.MathJax?.tex2svgPromise) {
        return window.MathJax;
    }

    if (!mathJaxPromise) {
        mathJaxPromise = (async () => {
            window.MathJax = createMathJaxConfig();

            await import("mathjax/es5/tex-svg-full.js");
            await window.MathJax.startup.promise;

            const stylesheet = window.MathJax.svgStylesheet?.();
            if (stylesheet && !document.head.contains(stylesheet)) {
                document.head.appendChild(stylesheet);
            }

            return window.MathJax;
        })().catch((error) => {
            mathJaxPromise = null;
            throw error;
        });
    }

    return mathJaxPromise;
}
